import React, { useEffect, useRef, useState } from 'react';
import { SizeBoxesLiNewV2, SizeBoxesNewContainer } from './styled';
import {
  DiscountStyle,
  LactomamaPackOuter,
  PackInfo,
  PackPrice,
  PPUText,
  Price,
  StrikePrice,
  TitleWrapper,
  VariantFeature,
  VariantTag,
} from '../../Product/HealthBundle/styled';
import Image from 'next/image';
import { mutate } from 'swr';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { getCartButton, productActionClick } from '../../../Utils/productAction';

function LactomamaFlavourBoxes(props) {
  const {
    varientTitle,
    sizeClickHandler,
    element,
    index,
    focusElement,
    selectedSize,
    setUserSelectedVariant,
    setSelectedVariant,
    userSelectedVariant,
    setUpdateVariant,
    updateVariant,
    generalItemsDataByFlavour,
    flavourTitles,
    setGeneralItems,
    setTabThemeColor,
  } = props;

    const [loaderState, setLoaderState] = useState('');
      const { data } = useGetCartData();
        const productData = {
    id: element.product_id,
  };
       const [cartButton, setCartButton] = useState(getCartButton(productData?.id));

  const getVariantFeatures = (type) => {
    return typeof window !== 'undefined' &&
      ((window.innerWidth > 720 && type == 'side') ||
        ((window.innerWidth < 720 || typeof window == 'undefined') &&
          type == 'top')) ? (
      <VariantFeature>
        {element?.variantFeature?.length
          ? element?.variantFeature?.map((innerElement, index) => {
              return <li key={`feature${index}`}>{innerElement.feature}</li>;
            })
          : null}
      </VariantFeature>
    ) : null;
  };

  let hideStrikeprice, discountPercent;

  if (element) {
    hideStrikeprice = element?.strikeprice - element?.price === 0;
    discountPercent = Math.floor(
      ((element?.strikeprice - element?.price) / element?.strikeprice) * 100,
    );
  } else {
    hideStrikeprice = element?.strikePrice - element?.price === 0;
    discountPercent = Math.floor(
      ((element?.strikePrice - element?.price) / element?.strikePrice) * 100,
    );
  }

 

 

  const onDoubleClick = () => {
   
    const selectedDataString = localStorage.getItem('selectedVariant');
    const data = JSON.parse(selectedDataString);
    if (data.hasOwnProperty('PACK')) {
      data.PACK = element?.title;
      localStorage.setItem('selectedVariant', JSON.stringify(data));
      setUpdateVariant(!updateVariant);
    }

    setUserSelectedVariant?.(element.product_id);
    setSelectedVariant?.(element.product_id);
  };

  const clickHandler = () => {
   
    const selectedDataString = localStorage.getItem('selectedVariant');
    const data = JSON.parse(selectedDataString);
    if (data.hasOwnProperty('PACK')) {
      data.PACK = element?.title;
      localStorage.setItem('selectedVariant', JSON.stringify(data));
      setUpdateVariant(!updateVariant);
    }

    setUserSelectedVariant?.(element.product_id);
    setSelectedVariant?.(element.product_id);
  };

  const doubleClickHandler = async () => {
    // If is LactoMama page and user has not selected any variant, then open the popup

        setLoaderState('loading');


    if (data) {
      await mutate('/api/getNewCartAmountOfUserWeb', null, false);
    }
   
    const apiResponse = await productActionClick(
      'cart',
      productData,
      cartButton,
    );
    if (apiResponse == true) {
      setTimeout(() => {
      
      }, 800);
      setLoaderState('loaded');
    } else {
      setLoaderState('');
     
    }
  };

  return varientTitle?.toLowerCase() == 'flavour' ? (
    <SizeBoxesNewContainer
      botPadding={varientTitle?.toLowerCase() != 'flavour'}
    >
      <SizeBoxesLiNewV2
        id={`${element.name + index}`}
        key={varientTitle + index}
        style={{
          opacity: focusElement == index ? 0.4 : 1
        }}
        onClick={() => sizeClickHandler(element, index)}
        active={selectedSize == element?.title}
        botPadding={varientTitle?.toLowerCase() == 'flavour'}
      >
        <>
          <p className="sizeTag">{element?.title}</p>
        </>
      </SizeBoxesLiNewV2>
    </SizeBoxesNewContainer>
  ) : (
    <LactomamaPackOuter
      lactoMamaCategory={true}
      selected={userSelectedVariant === element?.product_id}
      onClick={clickHandler}
      onDoubleClick={doubleClickHandler}
      style={{
        opacity: focusElement == index ? 0.4 : 1,
      }}
    >
      <PackInfo botPadding={element?.product_id != 3928}>
        <TitleWrapper selected={userSelectedVariant === element?.product_id}>
          <p className="title">{element?.title}</p>
          <div>{element?.subText}</div>
        </TitleWrapper>

        <div className="gridLayout">
          {!isDesktopUser() ? <div>{getVariantFeatures('top')}</div> : null}

          <div className="imageOuter">
            <Image
              src={element?.image_path || element?.image}
              alt={element?.title}
              className="image"
              sizes="33vw"
              layout="fill"
              quality={90}
            />
          </div>
          <div className="gridInner">
            {isDesktopUser() ? <div>{getVariantFeatures('side')}</div> : null}

            <p className="extraPadding">
              <Price>
                ₹{element?.price}
                &nbsp;
              </Price>
              <PackPrice>
                {!hideStrikeprice ? (
                  <>
                    <StrikePrice>
                      ₹{element?.strikeprice || element?.strikePrice}
                    </StrikePrice>
                    &nbsp;
                    <DiscountStyle>{discountPercent}% Off</DiscountStyle>
                  </>
                ) : (
                  <p>M.R.P.</p>
                )}
              </PackPrice>
              <PPUText>
                <p>
                  <b>{element?.ppuText || element?.ppuText}</b> {'/ 100 g'}
                </p>
              </PPUText>
            </p>
          </div>
        </div>
      </PackInfo>
      {[3928,4095,4097,4100].includes(element?.product_id) ? (
        <VariantTag isFertilityProduct={false}>
          <p>Bestseller</p>
        </VariantTag>
      ) : null}
    </LactomamaPackOuter>
  );
}

export default LactomamaFlavourBoxes;
